import { Action } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import * as Api from '../../api';
import { TApiFolder } from '../../api/endpoints/Folder';
import { TRootState } from '../reducers/RootReducer';
import ErrorHelpers from "../../utils/ErrorHelpers";

export const FOLDERS_FETCH_STARTED = 'FOLDERS_FETCH_STARTED';
export const FOLDERS_FETCH_COMPLETED = 'FOLDERS_FETCH_COMPLETED';
export const FOLDERS_FETCH_FAILED = 'FOLDERS_FETCH_FAILED';

export interface IFetchFoldersStartedAction {
  type: typeof FOLDERS_FETCH_STARTED
}

const fetchFoldersStarted = (): IFetchFoldersStartedAction => ({
  type: FOLDERS_FETCH_STARTED
});

export interface IFetchFoldersCompletedAction {
  type: typeof FOLDERS_FETCH_COMPLETED,
  data: Array<TApiFolder>
}

const fetchFoldersCompleted = (data: Array<TApiFolder>): IFetchFoldersCompletedAction => ({
  type: FOLDERS_FETCH_COMPLETED,
  data
});

export interface IFetchFoldersFailedAction {
  type: typeof FOLDERS_FETCH_FAILED,
  error: Error;
}

const fetchFoldersFailed = (error: Error): IFetchFoldersFailedAction => ({
  type: FOLDERS_FETCH_FAILED,
  error
});

const fetchFolders = () => {
  return async (dispatch: ThunkDispatch<TRootState, void, Action>): Promise<Array<TApiFolder>> => {
    try {
      dispatch(fetchFoldersStarted());

      const folders = await Api.Folder.list();

      dispatch(fetchFoldersCompleted(folders));

      return folders;
    } catch (error) {
      if (ErrorHelpers.isError(error)) {
        dispatch(fetchFoldersFailed(error));
      }

      throw error;
    }
  };
};

export const FOLDERS_CREATE_STARTED = 'FOLDERS_CREATE_STARTED';
export const FOLDERS_CREATE_COMPLETED = 'FOLDERS_CREATE_COMPLETED';
export const FOLDERS_CREATE_FAILED = 'FOLDERS_CREATE_FAILED';

const createFolderStarted = () => ({
  type: FOLDERS_CREATE_STARTED
});

export interface ICreateFoldersCompletedAction {
  type: typeof FOLDERS_CREATE_COMPLETED,
  data: TApiFolder
}

const createFolderCompleted = (folder: TApiFolder): ICreateFoldersCompletedAction => ({
  type: FOLDERS_CREATE_COMPLETED,
  data: folder
});

const createFolderFailed = (error: Error) => ({
  type: FOLDERS_CREATE_FAILED,
  error
});

const createFolder = (params: { name: string; }): ThunkAction<Promise<TApiFolder>, TRootState, void, Action> => {
  return async (dispatch: ThunkDispatch<{}, void, Action>): Promise<TApiFolder> => {
    try {
      dispatch(createFolderStarted());

      const folder = await Api.Folder.create(params);

      dispatch(createFolderCompleted(folder));

      return folder;
    } catch (error) {
      if (ErrorHelpers.isError(error)) {
        dispatch(createFolderFailed(error));
      }

      throw error;
    }
  }
}

export {
  createFolder,
  fetchFolders
};
